import { defineMessages } from 'react-intl';

const translations = {
  updatePositionsMessage: {
    id: 'pages.viewFulfilmentLocation.fulfilmentLocationSorting.updatePositionsMessage',
    defaultMessage: 'Positions are updated directly when sorting',
    description: 'Message of the fulfilment location position sorting',
  },
  tooManyPositionsMessage: {
    id: 'pages.viewFulfilmentLocation.fulfilmentLocationSorting.tooManyPositionsMessage',
    defaultMessage:
      'Too many positions to sort manually, use the bulk action to change the positions.',
    description:
      'Too many positions message of the positions list of the fulfilment location sorting',
  },
  feedback: {
    positionsUpdated: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationSorting.feedback.positionsUpdated',
      defaultMessage: 'Positions are updated',
      description: 'Success message of the fulfilment location update positions',
    },
    positionsNotUpdated: {
      id: 'pages.viewFulfilmentLocation.fulfilmentLocationSorting.feedback.positionsNotUpdated',
      defaultMessage: 'Positions could not be updated',
      description: 'Error message of the fulfilment location update positions',
    },
  },
};

export default defineMessages(translations);
